import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const getStatusColor = (status) => {
  const colors = {
    Pending: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    'Partially Delivered': 'bg-blue-100 text-blue-800 border-blue-300',
    Completed: 'bg-green-100 text-green-800 border-green-300',
    'Partially Cancelled': 'bg-orange-100 text-orange-800 border-orange-300',
    Cancelled: 'bg-red-100 text-red-800 border-red-300',
    // Legacy and delivery statuses
    'In Progress': 'bg-blue-100 text-blue-800 border-blue-300',
    Delayed: 'bg-red-100 text-red-800 border-red-300',
    Delivered: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  };
  return colors[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

export const isCancelledOrder = (status) => {
  return status === 'Cancelled' || status === 'Partially Cancelled';
};
